import { MediaProjectResponse } from "pages/media/types";

export function useMediaGenerationStatus(project?: MediaProjectResponse) {
  const mediaStatus = project?.media[0]?.status;
  const projectStatus = project?.status;

  const isStoryboardError = projectStatus === "StoryboardFailed";

  const isError =
    !isStoryboardError &&
    (mediaStatus === "Error" ||
      projectStatus === "DocumentError" ||
      (!!projectStatus && projectStatus.includes("Failed")));

  // Generation is complete when reaching these final states
  const isGenerationComplete =
    mediaStatus === "Ready" ||
    projectStatus === "MediaGenerated" ||
    projectStatus === "MediaGenerating" ||
    projectStatus === "Published";

  // Show loading when media exists but hasn't reached final state
  const isGenerating = !isError && !!project?.media[0] && !isGenerationComplete;

  return {
    isGenerating,
    isGenerationComplete,
    isError,
    isStoryboardError,
    mediaStatus,
    projectStatus,
  };
}
